import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Same Firebase project the vanilla app uses — see app/js/auth.js
const firebaseConfig = {
  apiKey: 'AIzaSyCBrpe0jJ6PemaCmnmA92YB3Vf-sqmxHg8',
  authDomain: 'fs-dw-478722.firebaseapp.com',
  projectId: 'fs-dw-478722',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const firebaseAuth = getAuth(firebaseApp)
